import type { SpotCatchSummary } from '../../types/api';
import { CatchFeed } from '../catches/CatchFeed';
import { fromSpotCatchSummary } from '../catches/catchRow';

interface Props {
  catches: SpotCatchSummary[];
}

export function LatestCatchesList({ catches }: Props) {
  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-5 shadow-sm">
      <h2 className="mb-4 text-base font-semibold text-slate-900 dark:text-slate-50">Latest Catches</h2>
      {catches.length === 0 ? (
        <p className="text-sm text-slate-500 dark:text-slate-400">No catches recorded at this spot yet.</p>
      ) : (
        <CatchFeed rows={catches.map(fromSpotCatchSummary)} />
      )}
    </div>
  );
}
